<span [ngClass]="data.state || 'white-circle'"></span>
&nbsp;{{ data.pc_number || 'No PC'}}